<template>
  <div id="app">
    <router-view/>
    <div class="vc-tigger" @click="toggleVc"></div>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    toggleVc(){
        const nowTime = new Date().getTime();
        if(nowTime - this.lastClickTime < 3000){
          this.count ++;
        } else {
          this.count = 0;
        }
        this.lastClickTime = nowTime;
        if(this.count >= 4) {
          let vconDom = document.getElementById('__vconsole').style.display = "block";;
          this.count = 0;
        }

    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
body,html{
  height: 100%;
}
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5,blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video,p {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    color: #222;
}
ol, ul {
    list-style: none;
}
input,textarea{
  outline:none;
}
.mint-msgbox{
    border-radius: .133333rem !important;
  }
  .mint-msgbox-content{
    min-height: .533333rem !important;
    padding: 1rem 0 !important;
  }
  .mint-msgbox-message{
    color: #222;
    font-size: .48rem !important;
    line-height: .533333rem !important;
    padding: 0 .266667rem !important;
  }
  .mint-msgbox-errormsg{
    padding: 0 .266667rem !important;
  }
  .mint-msgbox-btns{
    height: 1.333333rem !important;
    line-height: 1.333333rem !important;
    justify-content: space-between !important;
  }
  .mint-msgbox-btn{
    font-size: .48rem !important;
    line-height: 1.333333rem !important;
    flex: auto !important;
  }
  .mint-msgbox-cancel{
    color: #222;
  }
  .mint-msgbox-confirm{
    color: #d31145 !important;
  }
  .nolist{
    color: #222;
    font-size: .4rem;
    text-align: center;
    padding: .266667rem 0;
  }
  input{
    border: 0;
    background: transparent;
  }
  input::-webkit-input-placeholder {
    color: #666;
    font-size: .426667rem;
  }
  #__vconsole {
    display: none;
  }
  .vc-tigger{
    top: 0px;
    left: 0px;
    width: 50px;
    height: 50px;
    position: absolute;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue